module.exports = __webpack_public_path__ + "img/ring_g_skip_0_1.1ff11625.png";